import React from "react";
import { Navigate } from "react-router-dom";
import { WarningII } from "../../assets";
import { useSpectraSparks } from "../../api/queryHooks";
import UserAuthStore from "../../store/userStore";

function ForNewUserWhichIsNotColab({ space, user }) {
  const orgId = UserAuthStore((state) => state.orgId);
  const { data: sparksData } = useSpectraSparks(
    space.space_id,
    orgId,
    user?.uid,
    space.owner_id,
    { enabled: !!user?.uid && !!orgId && !!space.space_id }
  );
  const chats = sparksData?.sparks || [];
  
  if (chats && chats?.length) {
    return (
      <Navigate
        to={`/spectra/${space.space_id}/chat/${
          chats[0]?.id ? chats[0]?.id : chats[0]?.uid
        }`}
      />
    );
  }
  return (
    <div className="h-[75%] flex justify-center items-center flex-col">
      <WarningII className="fill-ink-hex-ffb450" />
      <h2 className="mt-6 mb-2 dark:text-ink-white text-ink-ink opacity-100 text-lg lg:text-xl font-bold word-break-normal">
        No sparks added in the spectra.
      </h2>
      <p className="dark:text-ink-copy-hover text-ink-control-border opacity-100 text-[13px] xm:text-sm">
        Please contact spectra owner for more details.
      </p>
    </div>
  );
}

export default ForNewUserWhichIsNotColab;
